import jwt_decode from "jwt-decode";

/**
 * The signed-in user's email address, taken from the access token.
 *
 * The redux `user.email` this app renders in the profile dropdown is never populated at
 * login — `completeLogin` stores the id, role, permissions, name and tenant, and no email —
 * so that field has always been blank. The token's `sub` is the address the user
 * authenticated with, is present on every token, and needs no request (KIN-1141).
 *
 * Returns "" rather than throwing on a missing or unreadable token: this is a label, and a
 * header must not fail to render because a token could not be parsed.
 */
export const getSignedInEmail = (
  token = typeof window === "undefined"
    ? null
    : sessionStorage.getItem("accessToken") ??
      localStorage.getItem("kinesin-accessToken")
) => {
  if (!token) return "";

  try {
    const { sub } = jwt_decode(token);

    // `sub` is an email in every token this app issues, but it is a general-purpose subject
    // claim — showing a bare user id in a slot labelled as an address would be worse than
    // showing nothing.
    return typeof sub === "string" && sub.includes("@") ? sub : "";
  } catch (error) {
    console.error("Could not read the signed-in email from the access token");

    return "";
  }
};
